/** @jsx isolateComponent */
import { css } from '@emotion/react';
import { isolateComponent, labelStyles } from '@zapier/style-encapsulation';

type Props = {
  /**
   * The content to render within the component.
   * Typically a `TableRow` component.
   */
  children: React.ReactNode;
};

const Styles = labelStyles('TableBody', {
  root: css`
    display: table-row-group;
  `,
});

/**
 * The `tbody` tag; use to display data.
 */
export const TableBody = (props: Props) => {
  return <tbody css={Styles.root}>{props.children}</tbody>;
};
